import "../src/global/global-pc"

import "@modules/vue-modals/ad-free"

import "@modules/static-pages/pc.css"
import "@modules/static-pages/pc_Inserieren_Form.css"
import "@modules/static-pages/pc_contact_Form.css"
import "@modules/solads/solads"
import "@modules/traffic-stars/traffic-stars"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
